// JavaScript Document	
function setCookie(cname,cvalue,exdays) {
	//alert("***");
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires=" + d.toGMTString();
    document.cookie = cname+"="+cvalue+"; "+expires;
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i=0; i<ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1);
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function checkCookie() {
    var user=getCookie("cookieVal");
    if (user != "") {
      // alert("Welcome again " + user);
		$(".cookies").css("display","none");
    } 
}

function close_cookies() {
	setCookie("cookieVal","isoleCookie",365);
	$(".cookies").addClass("invisibile");

	window.location.reload();
}


$(document).ready(function() {
   checkCookie();
    // double tup to go 'for menu in tablet'
    ;(function( $, window, document, undefined )
    {
        $.fn.doubleTapToGo = function( params )
        {
            if( !( 'ontouchstart' in window ) &&
                !navigator.msMaxTouchPoints &&
                !navigator.userAgent.toLowerCase().match( /windows phone os 7/i ) ) return false;

            this.each( function()
            {
                var curItem = false;

                $( this ).on( 'click', function( e )
                {
                    var item = $( this );
                    if( item[ 0 ] != curItem[ 0 ] )
                    {
                        e.preventDefault();
                        curItem = item;
                    }
                });

                $( document ).on( 'click touchstart MSPointerDown', function( e )
                {
                    var resetItem = true,
                        parents	  = $( e.target ).parents();

                    for( var i = 0; i < parents.length; i++ )
                        if( parents[ i ] == curItem[ 0 ] )
                            resetItem = false;

                    if( resetItem )
                        curItem = false;
                });
            });
            return this;
        };
    })( jQuery, window, document );
    // end double tup to go 'for menu in tablet'
    
    // comportamenti menu mobile
    $("#nav > a").on("click", function(){
        $("nav > ul").toggleClass("attivo-mob");
    });
    $("#nav > ul > li > .apri-sub").on("click", function(){
        $(this).siblings('ul').toggleClass("attivo");
        $(this).toggleClass("attivo");
    });
    $("#nav > ul > li li .apri-sub").on("click", function(){
        $(this).siblings('ul').toggleClass("attivo");
        $(this).toggleClass("attivo");
    });
    // end comportamenti menu mobile
    
    // menu servizio mobile
    if (Modernizr.mq('(max-width: 1024px)')) {
        $("ul.servizio .lingue p").on("click", function(){
            $("ul.servizio .lingue .lista").toggle();
        });
    }
    
    // link anchor animato in 'Didattica dettaglio'
    $(document).ready(function() {
        $("a.anchorLink").anchorAnimate()
    });

    jQuery.fn.anchorAnimate = function(settings) {

        settings = jQuery.extend({
            speed : 700
        }, settings);	

        return this.each(function(){
            var caller = this
            $(caller).click(function (event) {	
                event.preventDefault()
                var locationHref = window.location.href
                var elementClick = $(caller).attr("href")

                var destination = $(elementClick).offset().top;
                $("html:not(:animated),body:not(:animated)").animate({ scrollTop: destination}, settings.speed, function() {
                    window.location.hash = elementClick
                });
                return false;
            })
        })
    }
    
    // Freccia 'Torna su'
    if($(window).scrollTop() >600 )
        $(".torna-su").addClass("attivo");
    else
        $(".torna-su").removeClass("attivo");
    
    $(window).scroll(function(){
        if($(window).scrollTop() >600 )
            $(".torna-su").addClass("attivo");
        else
            $(".torna-su").removeClass("attivo");
    });
    
    $(".torna-su").click(function(){
        $(".torna-su").removeClass("attivo");
    });

	// Placeholder con ie8
	$('input, textarea').placeholder();
    
});

// elementi compaiono allo sroll
/* 
$(window).load(function() {
    $('.loader').hide();
    $('.viewme').addClass("ibm-hidden").viewportChecker({
        classToAdd: 'ibm-visible animated fadeIn', // Class to add to the elements when they are visible
        offset: 100    
    });
});
*/

$(window).scroll(function(){
    if ($(window).scrollTop() >= 1) {
       $('body').addClass('fixed');
    }
    else {
       $('body').removeClass('fixed');    
    }
    
});






